<template>
	<div class="game-intro">

		<h2 class="h2 game-intro__name">{{game.gameTitle}}</h2>
		<div class="game-intro__meta">

			<div class="grid grid--g32 grid--s24 grid--middle grid--auto">
				<div class="grid__item">

					<div class="grid grid--g6 grid--auto grid--middle">
						<div class="grid__item" v-for="channel in game.frequencyChannels">
							<span class="fonticon game-intro__channel" v-bind:class="'fonticon--' + channel"></span>
							<!-- <attr class="fonticon--phone fonticon--tablet fonticon--desktop fonticon--slot" /> -->
						</div>
					</div>

				</div>
			</div>
		</div>
        <div v-for="gameDetail in game.gameDetails">
            <div
                v-if="gameDetail.gameDetail"
                v-html="formatDescription(gameDetail.gameDetail)"
                class="game-intro__description listicon"
            />
        </div>
		<div class="grid grid--b32--not-phab grid--b12--phab grid--middle grid--auto game-intro__actions">
			<div class="grid__item">
				<PlayGameVideoButton :game="game" />
			</div>
			<div class="grid__item" v-if="game.gameCentre && game.gameCentre.length > 0 && game.gameCentre[0].hasChildren">
				<DownloadAssetsButton :game="game"></DownloadAssetsButton>
			</div>
		</div>
	</div>
</template>

<script>
import Btn from '../atoms/Btn'
import GameDates from '../molecules/GameDates'
import DownloadAssetsButton from '../organisms/DownloadAssetsButton'
import PlayGameVideoButton from '../organisms/PlayGameVideoButton.vue'

export default {
	name: 'FrequencyGameIntro',
	components: {
		Btn,
		GameDates,
		DownloadAssetsButton,
        PlayGameVideoButton
	},
	props: {
		game: Object,
	},
	methods: {
		formatDescription(str) {
			// Adapted from https://stackoverflow.com/a/7467865
			return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-intro";
	#{$c}
	{
		&__btns
		{
			margin-bottom: rem(16);
		}

		&__btn
		{
			padding-left: 12px;
			padding-right: 18px;
			font-size: 12px !important;
		}

		&__icon
		{
			font-size: rem(16);
			color: palette('yellow');
		}

		&__name
		{
			margin-bottom: rem(24);
		}

		&__meta
		{
			margin-bottom: rem(32);
		}

		&__separator
		{
			display: block;
			line-height: 0;
			width: 1px;
			height: rem(24);
			background-color: palette(divider);
		}

		&__date
		{
			@include extend(h5);
			margin-bottom: rem(8);
		}

		&__channel
		{
			font-size: rem(32);
		}

		&__description
		{
			color: palette('grey');

			@include media(not-phab)
			{
				max-width: 536px;
			}
		}

		&__actions
		{
			margin-top: rem(32);
		}
	}
	.listicon{
		position: relative;
		padding-left:30px;
		margin-bottom:10px;
		font-family: Lato, sans-serif;
	}
	.listicon:before{
		content:"";
		width:20px;
		height: 20px;
		left:0px;
		top:4px;
		display:block;
		position:absolute;
		background:url(../../assets/img/icons/listicon.png) 0 0 no-repeat;
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/FrequencyGameIntro.vue